import { render, staticRenderFns } from "./ProductGiroMin.vue?vue&type=template&id=13ad1cd2"
import script from "./ProductGiroMin.vue?vue&type=script&lang=js"
export * from "./ProductGiroMin.vue?vue&type=script&lang=js"
import style0 from "./ProductGiroMin.vue?vue&type=style&index=0&id=13ad1cd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports